<template>
  <div>
    <el-form :model="searchForm" class="search-form">
      <el-form-item label="" prop="dateTime" class="form-item" label-width="100">
        <el-date-picker v-model="dateTime" type="daterange" range-separator="-" start-placeholder="开始日期"
          end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="changeTime"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="fansIdOrName" label-width="100">
        <el-input :maxlength="255" v-model="searchForm.fans" placeholder="达人昵称/用户ID" />
      </el-form-item>
      <el-form-item label="结佣状态">
        <el-select v-model="searchForm.payStatus" placeholder="请选择结佣状态">
          <el-option v-for="item in payStatusList" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <!-- 操作按钮 -->
        <el-button type="warning" @click="onFormSearch">查询</el-button>
        <el-button type="warning" plain @click="onFormReset">重置</el-button>
        <el-button @click="onFormExport">导出数据</el-button>
      </el-form-item>
    </el-form>
    <div class="toolbar">
      <!-- 批量结佣 -->
      <batch-settle :ids="table.selectRowsIds" @refresh="onRefresh" />
      <set-settle-cycle @refresh="onRefresh" />
    </div>
    <!-- 表格-->
    <el-table ref="table" header-row-class-name="header" border highlight-current-row row-key="id"
      :data="table.dataSource" v-loading="table.loading" @selection-change="onSelectionChange">
      <el-table-column type="selection" min-width="80" align="center" reserve-selection />
      <el-table-column label="数据日期" min-width="180" prop="dataDateStr">
      </el-table-column>
      <el-table-column min-width="280" label="达人" prop="itemdateTimeStr">
        <template slot-scope="{ row }">
          <div class="table-user">
            <img :src="row.headImage
              ? row.headImage
              : require('../../../../assets/img/default_img.png')
              " />
            <div class="table-user__right">
              <div>{{ row.fansNickName }}</div>
              <div>用户ID：{{ row.fansId }}</div>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column min-width="180" prop="miniFloatRateStr">
        <template slot="header">
          <span>待结佣订单</span>
          <el-tooltip class="item" effect="dark" placement="top">
            <i class="el-icon-question"></i>
            <div slot="content">
              <p>已结算状态的订单可进行结佣</p>
            </div>
          </el-tooltip>
        </template>
        <template slot-scope="{ row }">
          <div>订单数：{{ row.settledCnt }}个</div>
          <div>订单金额：{{ row.settledAmount }}元</div>
        </template>
      </el-table-column>
      <el-table-column label="佣金" min-width="180" prop="settledCommission">
        <template slot-scope="{ row }">
          <span class="color-red">{{ row.settledCommission }}元</span>
        </template>
      </el-table-column>
      <el-table-column label="结佣状态" prop="waitSettle">
        <template slot-scope="{ row }">
          <div class="color-red" v-if="row.payStatus === 20">
            {{ row.payStatusStr }}
          </div>
          <div v-else>{{ row.payStatusStr }}</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页-->
    <el-pagination v-if="table.total" class="table-pagination" @size-change="onSizeChange"
      @current-change="onCurrentChange" :current-page.sync="pagination.pageNo" :page-sizes="[10, 20, 30, 40]"
      :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="table.total" />
  </div>
</template>

<script>
import douYin from "@/javaApi/douyin";
import batchSettle from "./BatchSettle";
import setSettleCycle from "./SetSettleCycle"
const DouYinModel = new douYin();
const searchParams = {
  dataBeginTime: "", // 开始日期
  dataEndTime: "", // 结束日期
  fans: "", // 粉丝ID或者名称
  payStatus: "",// 结佣状态
};
export default {
  components: {
    setSettleCycle,
    batchSettle,
  },
  props: {
    activeName: {
      // 激活名称
      type: String,
    },
  },
  data() {
    return {
      payStatusList: [
        {
          label: '全部',
          value: ''
        },
        {
          value: 0,
          label: '未结佣',
        },
        {
          value: 5,
          label: '结佣中',
        },
        {
          value: 20,
          label: '结佣失败',
        }],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      dateTime: [], // 日期
      searchForm: Object.assign({}, searchParams),
      pagination: {
        // 分页
        pageSize: 10, // 表格分页页数
        pageNo: 1, // 表格当前页数
      },
      table: {
        selectRowsIds: [], // 选中数据
        // 表格
        dataSource: [], // 表格数据
        total: 0, // 总数
        loading: false, // 表格加载loading
      },
    };
  },
  watch: {
    activeName: {
      immediate: true,
      handler: async function () {
        if (this.activeName === "first") {
          this.freshTable();
        }
      },
    },
  },
  methods: {
    // 刷新
    onRefresh() {
      this.clearTableSelection();
      this.freshTable();
    },
    // 改变日期
    changeTime(arr) {
      if (arr && arr.length) {
        this.searchForm.dataBeginTime = arr[0];
        this.searchForm.dataEndTime = arr[1];
      } else {
        this.searchForm.dataBeginTime = "";
        this.searchForm.dataEndTime = "";
      }
    },
    // 表格批量操作
    onSelectionChange(arr) {
      this.table.selectRowsIds = arr.map((item) => item.id);
    },
    // 表单搜素
    onFormSearch() {
      this.clearTableSelection();
      this.pagination.pageNo = 1;
      this.freshTable();
    },
    // 清空表格已选
    clearTableSelection() {
      if (
        this.$refs.table &&
        this.table.selectRowsIds &&
        this.table.selectRowsIds.length
      ) {
        this.$refs.table.clearSelection();
      }
    },
    // 表单重置
    onFormReset() {
      this.clearTableSelection();
      this.dateTime = [];
      this.searchForm = Object.assign({}, searchParams);
      this.pagination.pageSize = 10;
      this.onFormSearch();
    },
    // 转换数据
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + m + d;
    },
    // 导出
    onFormExport() {
      DouYinModel.unpaidCommissionExport(this.searchForm).then((res) => {
        const blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
        console.log("blob", blob);
        let url = window.URL.createObjectURL(blob);
        console.log("url", url);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.href = window.URL.createObjectURL(blob);
        a.download = "待结佣" + this.formatDate(new Date()) + ".xls";
        a.click();
        window.URL.revokeObjectURL(url);
        this.$message({
          message: "导出成功",
          type: "success",
        });
      });
    },

    // 分页数据变化
    onSizeChange(val) {
      this.pagination.pageSize = val;
      this.freshTable();
    },
    // 分页跳转
    onCurrentChange() {
      this.freshTable();
    },
    // 请求表格·
    async freshTable() {
      this.table.loading = true;
      const data = await DouYinModel.getUnpaidCommissionPage({
        ...this.pagination,
        ...this.searchForm,
      }).finally(() => {
        this.table.loading = false;
      });
      if (data.data.code === 200) {
        this.table.dataSource = data.data.data.list;
        this.table.total = data.data.data.total;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pc/douyin/distribution/UnpaidCommission.vue